import { useState, useEffect, CSSProperties } from "react";

declare const process: {
  env: {
    REACT_APP_GOOGLE_PLACES_API_KEY?: string;
    NEXT_PUBLIC_GOOGLE_PLACES_API_KEY?: string;
  };
};

declare global {
  interface Window {
    google?: any;
  }
}

const SUPABASE_URL = 'https://szbwqnllhhsawebwhrwj.supabase.co';
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InN6YndxbmxsaGhzYXdlYndocndqIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzI1MDAzNDgsImV4cCI6MjA4ODA3NjM0OH0.hRIxkoL41qrAYKaVt1iND9ZjILyDpAM5k0TG8lfqKrQ';

const GOOGLE_PLACES_API_KEY =
  process.env.REACT_APP_GOOGLE_PLACES_API_KEY ||
  process.env.NEXT_PUBLIC_GOOGLE_PLACES_API_KEY;
const T = {
  burgundy: "#4A0E0E", burgundyMid: "#6B1A1A", burgundyLight: "#8B2A2A",
  cream: "#F5F0E8", creamMuted: "#C8B89A", copper: "#8B6B4A",
  copperLight: "#B08A60", ink: "#0A0806", surface: "#120E0A",
  charcoalLight: "#3A2A22",
} as const;

const GLOBAL_CSS = `
  @import url('https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;1,300;1,400&family=Crimson+Pro:ital,wght@0,200;0,300;0,400;1,200;1,300&family=Josefin+Sans:wght@100;200;300&display=swap');
  *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
  body { background: #0A0806; color: #F5F0E8; font-family: 'Crimson Pro', Georgia, serif; -webkit-font-smoothing: antialiased; }
  @keyframes fadeUp { from { opacity: 0; transform: translateY(22px); } to { opacity: 1; transform: translateY(0); } }
  @keyframes pulse { 0%, 100% { opacity: 0.35; } 50% { opacity: 1; } }
  .sl-input { width: 100%; background: transparent; border: none; border-bottom: 1px solid #2A1A14; color: #F5F0E8; font-family: 'Crimson Pro', Georgia, serif; font-size: 16px; font-weight: 300; padding: 10px 0; outline: none; caret-color: #B08A60; transition: border-color 0.35s ease; }
  .sl-input::placeholder { color: #4A3020; font-style: italic; }
  .sl-input:focus { border-bottom-color: #8B6B4A; }
  .sl-input.has-error { border-bottom-color: #8B2A2A; }
  .sl-select { width: 100%; background: #120E0A; border: none; border-bottom: 1px solid #2A1A14; color: #F5F0E8; font-family: 'Josefin Sans', sans-serif; font-size: 11px; font-weight: 200; letter-spacing: 0.15em; padding: 10px 0; outline: none; cursor: pointer; appearance: none; transition: border-color 0.35s ease; }
  .sl-select:focus { border-bottom-color: #8B6B4A; }
  .sl-select option { background: #1A1008; }
  .sl-cta { position: relative; overflow: hidden; width: 100%; background: #4A0E0E; border: 1px solid #6B1A1A; color: #F5F0E8; font-family: 'Josefin Sans', sans-serif; font-weight: 300; font-size: 11px; letter-spacing: 0.4em; text-transform: uppercase; padding: 17px 48px; cursor: pointer; transition: background 0.4s ease, transform 0.2s ease; }
  .sl-cta:hover { background: #6B1A1A; transform: translateY(-1px); }
  .sl-cta:disabled { opacity: 0.38; cursor: not-allowed; transform: none; }
  .sl-btn-sm { background: none; border: 1px solid #3A2A22; color: #8B6B4A; font-family: 'Josefin Sans', sans-serif; font-weight: 200; font-size: 9px; letter-spacing: 0.3em; text-transform: uppercase; padding: 6px 14px; cursor: pointer; transition: all 0.25s ease; }
  .sl-btn-sm:hover { border-color: #8B6B4A; color: #F5F0E8; }
  .sl-btn-confirm { background: #1A3A1A; border: 1px solid #3A5A3A; color: #6AB06A; font-family: 'Josefin Sans', sans-serif; font-weight: 200; font-size: 9px; letter-spacing: 0.3em; text-transform: uppercase; padding: 6px 14px; cursor: pointer; transition: all 0.25s ease; }
  .sl-btn-confirm:hover { border-color: #6AB06A; color: #F5F0E8; }
  .sl-btn-danger { background: none; border: 1px solid #3A1010; color: #8B2A2A; font-family: 'Josefin Sans', sans-serif; font-weight: 200; font-size: 9px; letter-spacing: 0.3em; text-transform: uppercase; padding: 6px 14px; cursor: pointer; transition: all 0.25s ease; }
  .sl-btn-danger:hover { border-color: #8B2A2A; color: #F5F0E8; }
  .anim-fade-up { animation: fadeUp 0.7s cubic-bezier(0.25, 0.46, 0.45, 0.94) both; }

  html, body, #root {
    width: 100%;
    min-height: 100%;
    overflow-x: hidden;
  }

  @media (max-width: 768px) {
    .sl-dashboard-nav {
      padding: 0 16px !important;
    }

    .sl-dashboard-nav-inner {
      height: auto !important;
      min-height: 64px !important;
      flex-direction: column !important;
      align-items: flex-start !important;
      gap: 10px !important;
      padding: 12px 0 !important;
    }

    .sl-dashboard-nav-actions {
      width: 100% !important;
      justify-content: space-between !important;
      gap: 12px !important;
      overflow: visible !important;
      flex-wrap: nowrap !important;
    }

    .sl-dashboard-nav-actions span {
      max-width: calc(100% - 125px) !important;
      overflow: hidden !important;
      text-overflow: ellipsis !important;
      white-space: nowrap !important;
      display: block !important;
    }

    .sl-sign-out {
      flex-shrink: 0 !important;
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
    }

    .sl-dashboard-shell {
      padding: 128px 16px 56px !important;
      width: 100% !important;
    }

    .sl-tabs {
      overflow-x: auto !important;
      white-space: nowrap !important;
      margin-bottom: 32px !important;
      -webkit-overflow-scrolling: touch;
    }

    .sl-tabs button {
      flex-shrink: 0 !important;
      padding: 12px 16px 14px !important;
      letter-spacing: 0.22em !important;
    }

    .sl-event-row,
    .sl-applicant-row {
      flex-direction: column !important;
      align-items: stretch !important;
      gap: 18px !important;
    }

    .sl-event-actions {
      width: 100% !important;
      max-width: 100% !important;
      flex-direction: column !important;
      align-self: stretch !important;
      gap: 10px !important;
    }

    .sl-event-actions button,
    .sl-applicant-row button {
      display: block !important;
      width: 100% !important;
      max-width: 100% !important;
      padding: 10px 14px !important;
      text-align: center !important;
      white-space: normal !important;
    }

    .sl-form-grid {
      grid-template-columns: 1fr !important;
      gap: 24px !important;
    }
  }
`;

const PRODUCT_CATEGORIES = ["Wine","Sparkling Wine","Fortified Wine","American Whiskey","Scotch Whisky","Irish Whiskey","Tequila & Mezcal","Gin","Vodka","Rum","Cognac & Brandy","Sake","Hemp/THC","Mixed Portfolio"];
const TIER_REQUIRED = ["Introductory ($95)","Certified Sommelier ($175)","Advanced Sommelier ($300)","Master Sommelier ($550)"];
const US_STATES = ["AL","AK","AZ","AR","CA","CO","CT","DE","FL","GA","HI","ID","IL","IN","IA","KS","KY","LA","ME","MD","MA","MI","MN","MS","MO","MT","NE","NV","NH","NJ","NM","NY","NC","ND","OH","OK","OR","PA","RI","SC","SD","TN","TX","UT","VT","VA","WA","WV","WI","WY"];

interface Event {
  id: string;
  title: string;
  event_date: string;
  location_name: string;
  city: string;
  state: string;
  product_category: string;
  tier_required: string;
  duration_hours: number;
  notes: string;
  status: string;
  created_at: string;
}

interface EventForm {
  title: string;
  event_date: string;
  location_name: string;
  city: string;
  state: string;
  product_category: string;
  tier_required: string;
  duration_hours: string;
  notes: string;
}

type FormErrors = Partial<Record<keyof EventForm, string>>;

function getUser() {
  try {
    const u = JSON.parse(localStorage.getItem('sl_user') || 'null');
    if (!u) return null;
    if (!u.id && u.sub) u.id = u.sub;
    return u;
  } catch { return null; }
}

function getToken() { return localStorage.getItem('sl_token') || ''; }

function getUserId(): string {
  const token = getToken();
  if (!token) return '';
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.sub || '';
  } catch { return ''; }
}

function loadGooglePlacesScript(): Promise<void> {
  return new Promise((resolve, reject) => {
    if (window.google?.maps?.importLibrary) {
      resolve();
      return;
    }

    if (!GOOGLE_PLACES_API_KEY) {
      reject(new Error("Missing Google Places API key"));
      return;
    }

    const existingScript = document.querySelector(
      'script[src*="maps.googleapis.com/maps/api/js"]'
    );

    if (existingScript) {
      existingScript.addEventListener("load", () => resolve());
      existingScript.addEventListener("error", () =>
        reject(new Error("Failed to load Google Maps script"))
      );
      return;
    }

    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${GOOGLE_PLACES_API_KEY}&v=weekly&loading=async`;
    script.async = true;
    script.defer = true;

    script.onload = () => resolve();
    script.onerror = () =>
      reject(new Error("Failed to load Google Maps script"));

    document.head.appendChild(script);
  });
}

export default function ProducerDashboard() {
  const [view, setView] = useState<'events' | 'new-event' | 'applicants'>('events');
  const [events, setEvents] = useState<Event[]>([]);
  const [selectedEvent, setSelectedEvent] = useState<Event | null>(null);
  const [applicants, setApplicants] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [editingEvent, setEditingEvent] = useState<Event | null>(null);
  const [form, setForm] = useState<EventForm>({
    title: '', event_date: '', location_name: '', city: '', state: 'GA',
    product_category: '', tier_required: '', duration_hours: '', notes: ''
  });
  const [errors, setErrors] = useState<FormErrors>({});
  const [venueQuery, setVenueQuery] = useState("");
  const [venueSuggestions, setVenueSuggestions] = useState<any[]>([]);

  useEffect(() => {
    const tag = document.createElement('style');
    tag.innerHTML = GLOBAL_CSS;
    document.head.appendChild(tag);
    return () => { document.head.removeChild(tag); };
  }, []);

  useEffect(() => {
    const user = getUser();
    if (!user) { window.location.href = '/login'; return; }
    fetchEvents();
  }, []);

  useEffect(() => {
    if (view !== "new-event") return;

    loadGooglePlacesScript().catch((err) => {
      console.warn("Google Places autocomplete unavailable:", err.message);
    });
  }, [view]);

  useEffect(() => {
    let active = true;

    const fetchVenueSuggestions = async () => {
      if (view !== "new-event") return;
      if (!venueQuery.trim() || venueQuery.trim().length < 3) {
        setVenueSuggestions([]);
        return;
      }

      try {
        await loadGooglePlacesScript();

        if (!window.google?.maps?.importLibrary) return;

        const { AutocompleteSuggestion } =
          await window.google.maps.importLibrary("places");

        const { suggestions } =
          await AutocompleteSuggestion.fetchAutocompleteSuggestions({
            input: venueQuery,
            includedRegionCodes: ["us"],
          });

        if (active) {
          setVenueSuggestions(suggestions || []);
        }
      } catch (err: any) {
        console.warn("Google Places suggestions unavailable:", err.message);
        if (active) setVenueSuggestions([]);
      }
    };

    const timer = window.setTimeout(fetchVenueSuggestions, 300);

    return () => {
      active = false;
      window.clearTimeout(timer);
    };
  }, [venueQuery, view]);

  const fetchEvents = async () => {
    setLoading(true);
    const userId = getUserId();
    const token = getToken();
    try {
      const res = await fetch(`${SUPABASE_URL}/rest/v1/events?producer_id=eq.${userId}&order=created_at.desc`, {
        headers: { 'apikey': SUPABASE_ANON_KEY, 'Authorization': `Bearer ${token}` }
      });
      const data = await res.json();
      setEvents(Array.isArray(data) ? data : []);
    } catch { setEvents([]); }
    setLoading(false);
  };

  const fetchApplicants = async (eventId: string) => {
    const token = getToken();
    try {
      const res = await fetch(`${SUPABASE_URL}/rest/v1/bookings?event_id=eq.${eventId}&select=*,experts(*)&order=created_at.desc`, {
        headers: { 'apikey': SUPABASE_ANON_KEY, 'Authorization': `Bearer ${token}` }
      });
      const data = await res.json();

      if (!res.ok) {
        console.error('Failed to fetch applicants:', data);
        setApplicants([]);
        return;
      }

      setApplicants(Array.isArray(data) ? data : []);
    } catch (err) {
      console.error('Failed to fetch applicants:', err);
      setApplicants([]);
    }
  };

  const validate = (): FormErrors => {
    const e: FormErrors = {};
    if (!form.title.trim()) e.title = 'Required';
    if (!form.event_date) e.event_date = 'Required';
    if (!form.location_name.trim()) e.location_name = 'Required';
    if (!form.city.trim()) e.city = 'Required';
    if (!form.state) e.state = 'Required';
    if (!form.product_category) e.product_category = 'Required';
    if (!form.tier_required) e.tier_required = 'Required';
    if (!form.duration_hours) e.duration_hours = 'Required';
    return e;
  };

  const onChange = (key: keyof EventForm) => (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    setForm(f => ({ ...f, [key]: e.target.value }));
    if (errors[key]) setErrors(prev => { const n = { ...prev }; delete n[key]; return n; });
  };

  const handleSubmit = async () => {
    const e = validate();
    if (Object.keys(e).length) { setErrors(e); return; }
    setSubmitting(true);
    setError('');
    const userId = getUserId();
    const token = getToken();
    const payload = {
      producer_id: userId,
      title: form.title,
      event_date: form.event_date,
      location_name: form.location_name,
      city: form.city,
      state: form.state,
      product_category: form.product_category,
      tier_required: form.tier_required,
      duration_hours: parseFloat(form.duration_hours),
      notes: form.notes,
      status: 'open'
    };
    try {
      const url = editingEvent
        ? `${SUPABASE_URL}/rest/v1/events?id=eq.${editingEvent.id}`
        : `${SUPABASE_URL}/rest/v1/events`;
      const method = editingEvent ? 'PATCH' : 'POST';
      const res = await fetch(url, {
        method,
        headers: { 'Content-Type': 'application/json', 'apikey': SUPABASE_ANON_KEY, 'Authorization': `Bearer ${token}`, 'Prefer': 'return=minimal' },
        body: JSON.stringify(payload)
      });
      if (!res.ok) { const errText = await res.text(); throw new Error(errText); }
      setSuccess(editingEvent ? 'Event updated!' : 'Event posted! Experts can now apply.');
      setForm({ title: '', event_date: '', location_name: '', city: '', state: 'GA', product_category: '', tier_required: '', duration_hours: '', notes: '' });
      setVenueQuery("");
      setVenueSuggestions([]);
      setEditingEvent(null);
      fetchEvents();
      setTimeout(() => { setSuccess(''); setView('events'); }, 2000);
    } catch (err: any) {
      setError(err.message || 'Something went wrong.');
    }
    setSubmitting(false);
  };

  const handleCancel = async (eventId: string) => {
    if (!window.confirm('Cancel this event?')) return;
    const token = getToken();
    await fetch(`${SUPABASE_URL}/rest/v1/events?id=eq.${eventId}`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json', 'apikey': SUPABASE_ANON_KEY, 'Authorization': `Bearer ${token}`, 'Prefer': 'return=minimal' },
      body: JSON.stringify({ status: 'cancelled' })
    });
    fetchEvents();
  };

  const startEdit = (event: Event) => {
    setEditingEvent(event);
    setForm({
      title: event.title,
      event_date: event.event_date?.slice(0, 16) || '',
      location_name: event.location_name,
      city: event.city,
      state: event.state,
      product_category: event.product_category,
      tier_required: event.tier_required,
      duration_hours: String(event.duration_hours),
      notes: event.notes || ''
    });
    setVenueQuery(event.location_name || "");
    setVenueSuggestions([]);
    setView('new-event');
  };

  const handleConfirmExpert = async (bookingId: string) => {
    const token = getToken();

    try {
      const res = await fetch('/api/generate-compliance-pdf', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ bookingId }),
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.error || 'Failed to confirm expert and generate PDF.');
      }

      if (selectedEvent) fetchApplicants(selectedEvent.id);
    } catch (err: any) {
      alert(err.message || 'Failed to confirm expert and generate PDF.');
    }
  };

  const handleVenueSuggestionSelect = async (suggestion: any) => {
    const placePrediction = suggestion.placePrediction;
    if (!placePrediction) return;

    const place = placePrediction.toPlace();

    await place.fetchFields({
      fields: ["displayName", "formattedAddress", "addressComponents"],
    });

    const addressComponents = place.addressComponents || [];

    const getComponent = (type: string, useShortName = false): string => {
      const component = addressComponents.find((item: any) =>
        item.types?.includes(type)
      );

      if (!component) return "";

      return useShortName
        ? component.shortText || component.short_name || ""
        : component.longText || component.long_name || "";
    };

    const locationName = place.displayName || placePrediction.text?.text || "";
    const city =
      getComponent("locality") ||
      getComponent("postal_town") ||
      getComponent("administrative_area_level_2");

    const state = getComponent("administrative_area_level_1", true);

    setForm((prev) => ({
      ...prev,
      location_name: locationName || prev.location_name,
      city: city || prev.city,
      state: state || prev.state,
    }));

    setVenueQuery(locationName);
    setVenueSuggestions([]);

    setErrors((prev) => {
      const next = { ...prev };

      if (locationName) delete next.location_name;
      if (city) delete next.city;
      if (state) delete next.state;

      return next;
    });
  };

  const labelStyle = (hasError?: boolean): CSSProperties => ({
    display: 'block', fontFamily: "'Josefin Sans', sans-serif", fontWeight: 100,
    fontSize: 9, letterSpacing: '0.4em', textTransform: 'uppercase',
    color: hasError ? T.burgundyLight : T.copper, marginBottom: 8
  });

  const user = getUser();

  return (
    <div style={{ minHeight: '100vh', background: T.ink }}>
      <nav className="sl-dashboard-nav" style={{ position: 'fixed', top: 0, left: 0, right: 0, zIndex: 100, padding: '0 48px', background: 'rgba(10,6,4,0.97)', borderBottom: `1px solid ${T.charcoalLight}` }}>
        <div className="sl-dashboard-nav-inner" style={{ maxWidth: 1100, margin: '0 auto', height: 64, display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <div style={{ display: 'flex', alignItems: 'baseline', gap: 12 }}>
            <span style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 300, fontSize: 22, color: T.cream, letterSpacing: '0.08em', cursor: 'pointer' }} onClick={() => window.location.href = '/'}>SipLogic</span>
            <span style={{ width: 1, height: 12, background: T.burgundyMid, display: 'inline-block' }} />
            <span style={{ fontFamily: "'Josefin Sans', sans-serif", fontWeight: 100, fontSize: 9, color: T.copper, letterSpacing: '0.3em', textTransform: 'uppercase' }}>Producer Dashboard</span>
          </div>

          <div className="sl-dashboard-nav-actions" style={{ display: 'flex', gap: 24, alignItems: 'center' }}>
            <span style={{ fontFamily: "'Josefin Sans', sans-serif", fontWeight: 100, fontSize: 9, letterSpacing: '0.2em', color: T.copper }}>{user?.email}</span>
            <button
              className="sl-sign-out"
              onClick={() => {
                localStorage.clear();
                window.location.href = '/login';
              }}
              style={{
                background: 'transparent',
                border: `1px solid ${T.copper}`,
                cursor: 'pointer',
                fontFamily: "'Josefin Sans', sans-serif",
                fontWeight: 200,
                fontSize: 9,
                letterSpacing: '0.22em',
                textTransform: 'uppercase',
                color: T.creamMuted,
                padding: '7px 12px',
                whiteSpace: 'nowrap'
              }}
            >
              Sign Out
            </button>
          </div>
        </div>
      </nav>

      <div className="sl-dashboard-shell" style={{ maxWidth: 1100, margin: '0 auto', padding: '96px 24px 80px' }}>
        <div className="sl-tabs" style={{ display: 'flex', gap: 2, marginBottom: 48, borderBottom: `1px solid ${T.charcoalLight}` }}>
          {[{ id: 'events', label: 'My Events' }, { id: 'new-event', label: editingEvent ? 'Edit Event' : 'Post New Event' }].map(tab => (
            <button key={tab.id} onClick={() => { setView(tab.id as any); if (tab.id === 'events') { setEditingEvent(null); setForm({ title: '', event_date: '', location_name: '', city: '', state: 'GA', product_category: '', tier_required: '', duration_hours: '', notes: '' }); setVenueQuery(""); setVenueSuggestions([]); }}} style={{ background: 'none', border: 'none', borderBottom: `2px solid ${view === tab.id ? T.copper : 'transparent'}`, cursor: 'pointer', fontFamily: "'Josefin Sans', sans-serif", fontWeight: 200, fontSize: 10, letterSpacing: '0.35em', textTransform: 'uppercase', color: view === tab.id ? T.creamMuted : T.copper, padding: '12px 24px 14px', transition: 'all 0.25s ease' }}>
              {tab.label}
            </button>
          ))}
        </div>

        {view === 'events' && (
          <div className="anim-fade-up">
            {loading ? (
              <p style={{ fontFamily: "'Crimson Pro', serif", fontSize: 17, color: T.copper, fontStyle: 'italic', textAlign: 'center', marginTop: 60 }}>Loading your events…</p>
            ) : events.length === 0 ? (
              <div style={{ textAlign: 'center', marginTop: 80 }}>
                <p style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 300, fontSize: 32, color: T.creamMuted, marginBottom: 16 }}>No events yet.</p>
                <p style={{ fontFamily: "'Crimson Pro', serif", fontSize: 17, color: T.copper, fontStyle: 'italic', marginBottom: 32 }}>Post your first tasting event and start receiving expert applications.</p>
                <button className="sl-cta" style={{ width: 'auto', padding: '14px 40px' }} onClick={() => setView('new-event')}>Post Your First Event</button>
              </div>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                {events.map(event => (
                  <div key={event.id} style={{ background: T.surface, border: `1px solid ${event.status === 'cancelled' ? '#1A1010' : T.charcoalLight}`, padding: '24px 28px', opacity: event.status === 'cancelled' ? 0.5 : 1 }}>
                    <div className="sl-event-row" style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 16 }}>
                      <div style={{ flex: 1 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 12, marginBottom: 8 }}>
                          <span style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 400, fontSize: 22, color: T.cream }}>{event.title}</span>
                          <span style={{ fontFamily: "'Josefin Sans', sans-serif", fontWeight: 100, fontSize: 8, letterSpacing: '0.3em', textTransform: 'uppercase', color: event.status === 'open' ? T.copperLight : event.status === 'cancelled' ? T.burgundyLight : T.copper, border: `1px solid ${event.status === 'open' ? T.charcoalLight : 'transparent'}`, padding: '2px 8px' }}>{event.status}</span>
                        </div>
                        <div style={{ display: 'flex', gap: 24, flexWrap: 'wrap' }}>
                          {[
                            { label: 'Date', value: new Date(event.event_date).toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit' }) },
                            { label: 'Location', value: `${event.location_name} · ${event.city}, ${event.state}` },
                            { label: 'Category', value: event.product_category },
                            { label: 'Tier', value: event.tier_required },
                            { label: 'Duration', value: `${event.duration_hours} hrs` },
                          ].map(item => (
                            <div key={item.label}>
                              <div style={{ fontFamily: "'Josefin Sans', sans-serif", fontWeight: 100, fontSize: 8, letterSpacing: '0.3em', textTransform: 'uppercase', color: T.copper, marginBottom: 2 }}>{item.label}</div>
                              <div style={{ fontFamily: "'Crimson Pro', serif", fontSize: 15, color: T.creamMuted }}>{item.value}</div>
                            </div>
                          ))}
                        </div>
                      </div>
                      {event.status !== 'cancelled' && (
                        <div className="sl-event-actions" style={{ display: 'flex', gap: 8, flexShrink: 0 }}>
                          <button className="sl-btn-sm" onClick={() => { setSelectedEvent(event); fetchApplicants(event.id); setView('applicants'); }}>View Applicants</button>
                          <button className="sl-btn-sm" onClick={() => startEdit(event)}>Edit</button>
                          <button className="sl-btn-danger" onClick={() => handleCancel(event.id)}>Cancel</button>
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {view === 'applicants' && selectedEvent && (
          <div className="anim-fade-up">
            <button onClick={() => setView('events')} style={{ background: 'none', border: 'none', cursor: 'pointer', fontFamily: "'Josefin Sans', sans-serif", fontWeight: 100, fontSize: 9, letterSpacing: '0.3em', textTransform: 'uppercase', color: T.copper, marginBottom: 32 }}>← Back to Events</button>
            <h2 style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 300, fontSize: 30, color: T.cream, marginBottom: 8 }}>Applicants for {selectedEvent.title}</h2>
            <p style={{ fontFamily: "'Crimson Pro', serif", fontSize: 15, color: T.copper, fontStyle: 'italic', marginBottom: 32 }}>{new Date(selectedEvent.event_date).toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' })} · {selectedEvent.location_name}</p>
            {applicants.length === 0 ? (
              <p style={{ fontFamily: "'Crimson Pro', serif", fontSize: 17, color: T.copper, fontStyle: 'italic' }}>No applications yet. Experts will appear here once they apply.</p>
            ) : (
              <div style={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                {applicants.map((app, i) => (
                  <div key={i} className="sl-applicant-row" style={{ background: T.surface, border: `1px solid ${T.charcoalLight}`, padding: '20px 24px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div>
                      <div style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 20, color: T.cream, marginBottom: 4 }}>{app.experts?.full_name || app.experts?.email || app.expert_id}</div>
                      <div style={{ fontFamily: "'Josefin Sans', sans-serif", fontWeight: 100, fontSize: 9, letterSpacing: '0.3em', textTransform: 'uppercase', color: app.status === 'confirmed' ? '#6AB06A' : T.copper }}>{app.status}</div>
                    </div>
                    <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', justifyContent: 'flex-end' }}>
                      {app.status === 'applied' && (
  <button className="sl-btn-confirm" onClick={() => handleConfirmExpert(app.id)}>
    Confirm Expert
  </button>
)}

                      {app.compliance_pdf_url && (
                        <button
                          className="sl-btn-sm"
                          onClick={() => window.open(app.compliance_pdf_url, '_blank')}
                        >
                          Download PDF
                        </button>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {view === 'new-event' && (
          <div className="anim-fade-up" style={{ maxWidth: 640 }}>
            <h2 style={{ fontFamily: "'Cormorant Garamond', serif", fontWeight: 300, fontSize: 34, color: T.cream, marginBottom: 8 }}>{editingEvent ? 'Edit Event' : 'Post a Tasting Event'}</h2>
            <p style={{ fontFamily: "'Crimson Pro', serif", fontSize: 17, color: T.copper, fontStyle: 'italic', marginBottom: 40 }}>Certified experts will be able to browse and apply to your event.</p>

            <div style={{ display: 'flex', flexDirection: 'column', gap: 32 }}>
              <div>
                <label style={labelStyle(!!errors.title)}>Event Title {errors.title && <span style={{ color: T.burgundyLight, marginLeft: 8 }}>— {errors.title}</span>}</label>
                <input className={`sl-input${errors.title ? ' has-error' : ''}`} placeholder="e.g. Eagle Rock Vineyard Fall Tasting" value={form.title} onChange={onChange('title')} />
              </div>

              <div>
                <label style={labelStyle(!!errors.event_date)}>Date & Time {errors.event_date && <span style={{ color: T.burgundyLight, marginLeft: 8 }}>— {errors.event_date}</span>}</label>
                <input className={`sl-input${errors.event_date ? ' has-error' : ''}`} type="datetime-local" value={form.event_date} onChange={onChange('event_date')} style={{ colorScheme: 'dark' }} />
              </div>

              <div>
                <label style={labelStyle(!!errors.location_name)}>
                  Venue / Retailer Name{" "}
                  {errors.location_name && (
                    <span style={{ color: T.burgundyLight, marginLeft: 8 }}>
                      — {errors.location_name}
                    </span>
                  )}
                </label>

                <div style={{ position: "relative" }}>
                  <input
                    className={`sl-input${errors.location_name ? " has-error" : ""}`}
                    placeholder="e.g. Total Wine Buckhead"
                    value={venueQuery || form.location_name}
                    onChange={(e) => {
                      const value = e.target.value;
                      setVenueQuery(value);
                      setForm((prev) => ({ ...prev, location_name: value }));
                      if (errors.location_name) {
                        setErrors((prev) => {
                          const next = { ...prev };
                          delete next.location_name;
                          return next;
                        });
                      }
                    }}
                  />

                  {venueSuggestions.length > 0 && (
                    <div
                      style={{
                        position: "absolute",
                        top: "100%",
                        left: 0,
                        right: 0,
                        zIndex: 300,
                        background: "#120E0A",
                        border: `1px solid ${T.charcoalLight}`,
                        marginTop: 6,
                        maxHeight: 220,
                        overflowY: "auto",
                      }}
                    >
                      {venueSuggestions.map((suggestion, index) => {
                        const text =
                          suggestion.placePrediction?.text?.text ||
                          suggestion.placePrediction?.mainText?.text ||
                          "Unnamed place";

                        return (
                          <button
                            key={index}
                            type="button"
                            onClick={() => handleVenueSuggestionSelect(suggestion)}
                            style={{
                              width: "100%",
                              background: "transparent",
                              border: "none",
                              borderBottom: `1px solid ${T.charcoalLight}`,
                              color: T.creamMuted,
                              textAlign: "left",
                              padding: "10px 12px",
                              cursor: "pointer",
                              fontFamily: "'Crimson Pro', serif",
                              fontSize: 15,
                            }}
                          >
                            {text}
                          </button>
                        );
                      })}
                    </div>
                  )}
                </div>
              </div>

              <div className="sl-form-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 120px', gap: 24 }}>
                <div>
                  <label style={labelStyle(!!errors.city)}>
                    {`City ${errors.city ? `— ${errors.city}` : ''}`}
                  </label>

                  <input
                    className={`sl-input${errors.city ? ' has-error' : ''}`}
                    placeholder="Atlanta"
                    value={form.city}
                    onChange={onChange('city')}
                  />
                </div>
                <div>
                  <label style={labelStyle(!!errors.state)}>State</label>
                  <div style={{ position: 'relative' }}>
                    <select className="sl-select" value={form.state} onChange={onChange('state')}>
                      {US_STATES.map(s => <option key={s} value={s}>{s}</option>)}
                    </select>
                    <span style={{ position: 'absolute', right: 0, top: '50%', transform: 'translateY(-50%)', color: T.copper, fontSize: 10, pointerEvents: 'none' }}>▾</span>
                  </div>
                </div>
              </div>

              <div>
                <label style={labelStyle(!!errors.product_category)}>Product Category {errors.product_category && <span style={{ color: T.burgundyLight, marginLeft: 8 }}>— {errors.product_category}</span>}</label>
                <div style={{ position: 'relative' }}>
                  <select className={`sl-select${errors.product_category ? ' has-error' : ''}`} value={form.product_category} onChange={onChange('product_category')}>
                    <option value="">Select category…</option>
                    {PRODUCT_CATEGORIES.map(c => <option key={c} value={c}>{c}</option>)}
                  </select>
                  <span style={{ position: 'absolute', right: 0, top: '50%', transform: 'translateY(-50%)', color: T.copper, fontSize: 10, pointerEvents: 'none' }}>▾</span>
                </div>
              </div>

              <div>
                <label style={labelStyle(!!errors.tier_required)}>Minimum Expert Tier Required {errors.tier_required && <span style={{ color: T.burgundyLight, marginLeft: 8 }}>— {errors.tier_required}</span>}</label>
                <div style={{ position: 'relative' }}>
                  <select className={`sl-select${errors.tier_required ? ' has-error' : ''}`} value={form.tier_required} onChange={onChange('tier_required')}>
                    <option value="">Select tier…</option>
                    {TIER_REQUIRED.map(t => <option key={t} value={t}>{t}</option>)}
                  </select>
                  <span style={{ position: 'absolute', right: 0, top: '50%', transform: 'translateY(-50%)', color: T.copper, fontSize: 10, pointerEvents: 'none' }}>▾</span>
                </div>
              </div>

              <div>
                <label style={labelStyle(!!errors.duration_hours)}>Duration {errors.duration_hours && <span style={{ color: T.burgundyLight, marginLeft: 8 }}>— {errors.duration_hours}</span>}</label>
                <div style={{ position: 'relative' }}>
                  <select className="sl-select" value={form.duration_hours} onChange={onChange('duration_hours')}>
                    <option value="">Select duration…</option>
                    <option value="2">2 Hours</option>
                    <option value="3">3 Hours</option>
                    <option value="4">Dinner Event</option>
                  </select>
                  <span style={{ position: 'absolute', right: 0, top: '50%', transform: 'translateY(-50%)', color: T.copper, fontSize: 10, pointerEvents: 'none' }}>▾</span>
                </div>
              </div>

              <div>
                <label style={labelStyle()}>Additional Notes <span style={{ color: T.charcoalLight }}>(optional)</span></label>
                <textarea className="sl-input" placeholder="Any special instructions, products to feature, dress code, parking info…" value={form.notes} onChange={onChange('notes')} rows={3} style={{ resize: 'none', lineHeight: 1.65 }} />
              </div>

              {error && <p style={{ fontFamily: "'Crimson Pro', serif", fontSize: 14, color: T.burgundyLight, fontStyle: 'italic' }}>{error}</p>}
              {success && <p style={{ fontFamily: "'Crimson Pro', serif", fontSize: 14, color: T.copperLight, fontStyle: 'italic' }}>{success}</p>}

              <button className="sl-cta" onClick={handleSubmit} disabled={submitting}>
                {submitting ? <span style={{ animation: 'pulse 1s ease-in-out infinite' }}>◈ &nbsp; Saving…</span> : editingEvent ? 'Update Event' : 'Post Event'}
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}